export default __webpack_public_path__ + "static/media/tunein.84ac5e42.svg";